module.exports = __webpack_public_path__ + "img/america-3.574be203.png";